import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from '../../AuthContext';
import Logo from "../../assets/Img/Logo-1.png";
import UserImg from "../../assets/Img/User.gif";
import "../../App.css";

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export default function WorkerTaskApp() {
  const { user, logout } = useContext(AuthContext);
  const workerId = user?.EmployeeID || '';
  const workerName = user?.Name || '';
  const [hover, setHover] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const [activeTask, setActiveTask] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Scanning state
  const [barcode, setBarcode] = useState('');
  const [scannedLot, setScannedLot] = useState(null);

  // Claim state
  const [showStartOptions, setShowStartOptions] = useState(false);
  const [targetQty, setTargetQty] = useState('');

  // Completion state
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [completedQty, setCompletedQty] = useState('');

  // Timer state
  const [elapsed, setElapsed] = useState('00:00:00');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (workerId) {
      fetchActiveTask();
    }
  }, [workerId]);

  useEffect(() => {
    let interval;
    if (activeTask) {
      interval = setInterval(() => {
        const start = new Date(activeTask.start_time);
        const now = new Date();
        const diff = Math.floor((now - start) / 1000);
        
        const hrs = String(Math.floor(diff / 3600)).padStart(2, '0');
        const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
        const secs = String(diff % 60).padStart(2, '0');
        
        setElapsed(`${hrs}:${mins}:${secs}`);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [activeTask]);

  const fetchActiveTask = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/active/${workerId}`);
      if (res.data.success && res.data.hasActive) {
        setActiveTask(res.data.task);
      } else {
        setActiveTask(null);
      }
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Failed to fetch active task', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleScan = async (e) => {
    e.preventDefault();
    if (!barcode.trim()) return;

    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/${barcode.trim()}`);
      if (res.data.success && res.data.available) {
        setScannedLot(res.data);
      } else {
          // It might be success=true but available=false (0 qty left)
          Swal.fire('Notice', res.data.message || 'Lot not found or no qty available', 'warning');
      }
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Lot not found', 'error');
    } finally {
      setLoading(false);
    }
  };

  const startTask = async () => {
    const claimAmt = parseInt(targetQty);
    if (!claimAmt || claimAmt <= 0) return Swal.fire('Error', 'Invalid qty', 'error');
    if (claimAmt > scannedLot.availableQty) return Swal.fire('Error', `Max available is ${scannedLot.availableQty}`, 'error');

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/claim`, {
        worker_id: workerId,
        worker_name: workerName,
        lot_id: scannedLot.lot_id,
        confirm_time_new_id: scannedLot.confirmTimeNewId,
        claimed_qty: claimAmt
      });
      if (res.data.success) {
        Swal.fire('Started!', 'Timer has started.', 'success');
        resetScanner();
        fetchActiveTask();
      }
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to start task', 'error');
    } finally {
      setLoading(false);
    }
  };

  const resetScanner = () => {
    setScannedLot(null);
    setBarcode('');
    setShowStartOptions(false);
    setTargetQty('');
  };

  const completeTask = async () => {
    if (!completedQty) return Swal.fire('Validation Error', 'Enter completed quantity.', 'warning');
    
    if (parseInt(completedQty) > activeTask.claimed_qty) {
      return Swal.fire('Error', `Aapne sirf ${activeTask.claimed_qty} pcs claim kiye the. Isse zyada complete nahi kar sakte!`, 'error');
    }

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/complete`, {
        log_id: activeTask.log_id,
        completed_qty: parseInt(completedQty)
      });
      if (res.data.success) {
        Swal.fire('Completed!', res.data.message, 'success');
        setShowCompleteModal(false);
        setCompletedQty('');
        setActiveTask(null);
      }
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to complete task', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!workerId) {
    window.location.href = "/";
    return null;
  }

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      
      {/* NAVBAR */}
      <nav
        className="navbar navbar-expand-lg bg-body-white"
        style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.2) ", background: "white" }}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/User-dashboard">
            <img
              src={Logo}
              className="img-fluid rounded-top"
              alt="Logo"
              style={{ height: "40px", marginLeft: "10px" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/User-dashboard"
                  style={{ color: "inherit", fontWeight: "600" }}
                >
                  <i className="bi bi-house-door me-1"></i> HOME
                </a>
              </li>
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/User-Tickets"
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{ color: hover ? "#ff0000" : "inherit", fontWeight: "600" }}
                >
                  <i className="bi bi-ticket-detailed me-1"></i> TICKET
                </a>
              </li>
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/wip-worker-app"
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{ color: hover ? "#ff0000" : "inherit" }}
                >
                  <i className="bi bi-stopwatch me-1"></i> TASK TRACKER
                </a>
              </li>
            </ul>

            <span style={{ marginRight: "20px" }}>Welcome, {user?.Name}! </span>
            
            <div className="dropdown">
              <a
                className="d-flex align-items-center text-decoration-none dropdown-toggle ml-5"
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  marginRight: "20px",
                  justifyContent: "end",
                  marginLeft: "10px",
                  ...(isMobile && { marginTop: "-41px" }),
                }}
              >
                <img
                  src={UserImg}
                  alt="Profile"
                  className="rounded-circle"
                  style={{ width: "40px", height: "40px", objectFit: "cover" }}
                />
              </a>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                <li>
                  <a className="dropdown-item text-danger" style={{ cursor: "pointer" }} onClick={logout}>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      {/* END NAVBAR */}

      <div style={{ padding: "40px 20px", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", maxWidth: "550px" }}>
          
          {loading && !activeTask && <div style={{ textAlign: "center", padding: "20px" }}><i className="bi bi-hourglass-split spin fs-2 text-primary"></i></div>}

          {/* ACTIVE TASK VIEW */}
          {activeTask && !loading && (
            <div style={{ background: "white", borderRadius: "24px", overflow: "hidden", boxShadow: "0 20px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0" }}>
              <div style={{ background: "linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%)", padding: "40px 24px", textAlign: "center", position: "relative" }}>
                
                <div style={{ position: "absolute", top: "16px", left: "16px" }}>
                  <span style={{ background: "rgba(255,255,255,0.2)", backdropFilter: "blur(4px)", color: "white", padding: "6px 16px", borderRadius: "30px", fontSize: "13px", fontWeight: 700, letterSpacing: "1px" }}>
                    <i className="bi bi-activity me-2"></i>IN PROGRESS
                  </span>
                </div>

                <div style={{ fontSize: isMobile ? "48px" : "64px", fontWeight: 800, color: "white", fontFamily: "monospace", letterSpacing: "-2px", textShadow: "0 4px 10px rgba(0,0,0,0.1)", marginTop: "16px" }}>
                  {elapsed}
                </div>
                <div style={{ color: "rgba(255,255,255,0.8)", fontWeight: 500, fontSize: "15px", marginTop: "8px", textTransform: "uppercase", letterSpacing: "1px" }}>Time Elapsed</div>
              </div>

              <div style={{ padding: "32px", display: "flex", flexDirection: "column", gap: "20px", background: "white" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                  <span style={{ color: "#64748b", fontWeight: 600, fontSize: "15px" }}>Lot ID</span>
                  <span style={{ color: "#0f172a", fontWeight: 800, fontSize: "16px" }}>{activeTask.lot_id}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                  <span style={{ color: "#64748b", fontWeight: 600, fontSize: "15px" }}>Department</span>
                  <span style={{ color: "#0ea5e9", fontWeight: 800, fontSize: "16px", background: "#e0f2fe", padding: "4px 12px", borderRadius: "8px" }}>{activeTask.department || 'N/A'}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                  <span style={{ color: "#64748b", fontWeight: 600, fontSize: "15px" }}>Supervisor</span>
                  <span style={{ color: "#0f172a", fontWeight: 800, fontSize: "16px" }}>{activeTask.supervisor || '-'}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ color: "#64748b", fontWeight: 600, fontSize: "15px" }}>Your Claimed Qty</span>
                  <span style={{ background: "#f1f5f9", color: "#334155", padding: "4px 12px", borderRadius: "12px", fontWeight: 800 }}>{activeTask.claimed_qty} pcs</span>
                </div>

                {!showCompleteModal ? (
                  <button 
                    onClick={() => setShowCompleteModal(true)}
                    style={{ width: "100%", padding: "18px", background: "#10b981", color: "white", border: "none", borderRadius: "16px", fontSize: "18px", fontWeight: 700, marginTop: "24px", boxShadow: "0 10px 15px -3px rgba(16, 185, 129, 0.3)", transition: "all 0.2s" }}
                    onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <i className="bi bi-check-circle-fill me-2"></i> FINISH WORK
                  </button>
                ) : (
                  <div style={{ marginTop: "24px", background: "#f8fafc", padding: "24px", borderRadius: "16px", border: "2px solid #e2e8f0" }}>
                    <label style={{ fontWeight: 700, color: "#1e293b", display: "block", marginBottom: "12px" }}>How many pieces did you complete?</label>
                    <input 
                      type="number" 
                      value={completedQty}
                      onChange={e => {
                        const val = e.target.value;
                        if (val === '' || parseInt(val) <= activeTask.claimed_qty) {
                          setCompletedQty(val);
                        }
                      }}
                      placeholder={`Max: ${activeTask.claimed_qty}`}
                      max={activeTask.claimed_qty}
                      min="1"
                      style={{ width: "100%", padding: "16px", borderRadius: "12px", border: "2px solid #cbd5e1", marginBottom: "20px", fontSize: "18px", fontWeight: 600, textAlign: "center" }}
                    />
                    <div style={{ display: "flex", gap: "12px" }}>
                      <button onClick={() => setShowCompleteModal(false)} style={{ flex: 1, padding: "14px", background: "white", border: "2px solid #cbd5e1", color: "#64748b", borderRadius: "12px", fontWeight: 700, fontSize: "15px" }}>Cancel</button>
                      <button onClick={completeTask} disabled={loading} style={{ flex: 1, padding: "14px", background: "#10b981", color: "white", border: "none", borderRadius: "12px", fontWeight: 700, fontSize: "15px", boxShadow: "0 4px 6px -1px rgba(16, 185, 129, 0.3)" }}>Submit</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* IDLE VIEW (Scan New Lot) */}
          {!activeTask && !loading && (
            <div style={{ animation: "fadeIn 0.4s ease-out" }}>
              <div style={{ background: "white", padding: "32px", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.06)", marginBottom: "24px", border: "1px solid #f1f5f9" }}>
                <div style={{ textAlign: "center", marginBottom: "24px" }}>
                  <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "64px", height: "64px", background: "#eff6ff", color: "#3b82f6", borderRadius: "50%", marginBottom: "16px", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)" }}>
                    <i className="bi bi-search fs-3"></i>
                  </div>
                  <h4 style={{ fontWeight: 800, color: "#0f172a", margin: 0 }}>Find Lot ID</h4>
                  <p style={{ color: "#64748b", margin: "8px 0 0 0", fontSize: "15px" }}>Enter the lot number to start your task</p>
                </div>
                
                <form onSubmit={handleScan}>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <input 
                      type="text" 
                      value={barcode} 
                      onChange={(e) => setBarcode(e.target.value.toUpperCase())}
                      placeholder="e.g. TEST-LOT-001"
                      autoFocus
                      style={{ flex: 1, padding: "16px", borderRadius: "12px", border: "2px solid #e2e8f0", fontSize: "16px", outline: "none", fontWeight: 600, transition: "border-color 0.2s" }}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
                    />
                    <button type="submit" disabled={!barcode.trim()} style={{ background: "#3b82f6", color: "white", border: "none", padding: "0 28px", borderRadius: "12px", fontWeight: 700, fontSize: "16px", boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.3)" }}>
                      FIND
                    </button>
                  </div>
                </form>
              </div>

              {scannedLot && (
                <div style={{ background: "white", borderRadius: "24px", overflow: "hidden", boxShadow: "0 20px 40px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9", animation: "slideUp 0.3s ease-out" }}>
                  <div style={{ padding: "24px 32px", borderBottom: "1px solid #f8fafc", background: "#f8fafc" }}>
                    <h5 style={{ margin: 0, fontWeight: 800, color: "#0f172a", display: "flex", alignItems: "center" }}>
                      <i className="bi bi-box-seam me-2 text-primary"></i> Lot Found
                    </h5>
                  </div>
                  <div style={{ padding: "32px", display: "flex", flexDirection: "column", gap: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                      <span style={{ color: "#64748b", fontWeight: 600 }}>Lot ID</span>
                      <span style={{ color: "#0f172a", fontWeight: 800 }}>{scannedLot.lot_id}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                      <span style={{ color: "#64748b", fontWeight: 600 }}>Department</span>
                      <span style={{ color: "#0ea5e9", fontWeight: 800, background: "#e0f2fe", padding: "4px 12px", borderRadius: "8px" }}>{scannedLot.department || 'N/A'}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                      <span style={{ color: "#64748b", fontWeight: 600 }}>Supervisor</span>
                      <span style={{ color: "#0f172a", fontWeight: 800 }}>{scannedLot.supervisor || '-'}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: "1px dashed #cbd5e1" }}>
                      <span style={{ color: "#64748b", fontWeight: 600 }}>Total Lot Qty</span>
                      <span style={{ color: "#0f172a", fontWeight: 800 }}>{scannedLot.totalQty} pcs</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ color: "#64748b", fontWeight: 600 }}>Available Qty</span>
                      <span style={{ color: "#10b981", fontWeight: 800, fontSize: "18px" }}>{scannedLot.availableQty} pcs</span>
                    </div>

                    {!showStartOptions ? (
                      <button 
                        onClick={() => setShowStartOptions(true)}
                        style={{ width: "100%", padding: "18px", background: "#3b82f6", color: "white", border: "none", borderRadius: "16px", fontSize: "18px", fontWeight: 800, marginTop: "24px", boxShadow: "0 10px 15px -3px rgba(59, 130, 246, 0.4)", transition: "all 0.2s" }}
                      >
                        <i className="bi bi-play-fill me-2"></i> PROCEED TO START
                      </button>
                    ) : (
                      <div style={{ marginTop: "16px", background: "#f8fafc", padding: "20px", borderRadius: "16px", border: "2px solid #e2e8f0", animation: "slideUp 0.3s ease-out" }}>
                        <div style={{ marginBottom: "20px" }}>
                          <label style={{ fontWeight: 700, color: "#1e293b", display: "block", marginBottom: "8px" }}>How many pieces will you work on?</label>
                          <input 
                            type="number" 
                            value={targetQty}
                            onChange={(e) => setTargetQty(e.target.value)}
                            placeholder={`Max available: ${scannedLot.availableQty}`}
                            style={{ width: "100%", padding: "14px", borderRadius: "12px", border: "2px solid #cbd5e1", fontSize: "16px", fontWeight: 600 }}
                          />
                        </div>
                        
                        <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
                          <button 
                            onClick={startTask}
                            disabled={loading || !targetQty}
                            style={{ flex: 1, padding: "14px", background: "#10b981", color: "white", border: "none", borderRadius: "12px", fontWeight: 800, fontSize: "16px", boxShadow: "0 4px 6px -1px rgba(16, 185, 129, 0.3)" }}
                          >
                            START WORK
                          </button>
                        </div>
                      </div>
                    )}
                    
                    <button 
                      onClick={() => { setScannedLot(null); setShowStartOptions(false); setTargetQty(''); }}
                      style={{ width: "100%", padding: "14px", background: "transparent", color: "#64748b", border: "none", fontWeight: 700, fontSize: "15px", marginTop: "4px" }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

        </div>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
